import React, {useRef} from "react";
import useResizeObserver from "../../../hooks/useResizeObserver";
import {getBoxSize} from "../../../../../utils";
import EpmsImage from "../../../../Common/EpmsImage";
import makeStyles from "@material-ui/core/styles/makeStyles";
import useImagePreview from "../../../hooks/useImagePreview";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";

const useStyles = makeStyles(theme => ({
  orderLineImage: {
    flexGrow: 1,
  },
  qualityWarning: {
    position: 'absolute',
    color: 'yellow',
    right: 0,
    bottom: 0,
  }
}));

export default ({product, file, filter, cropRect, whiteBorder, adaption}) => {
  let ref = useRef(null);
  const classes = useStyles();
  const containerSize = useResizeObserver(ref);
  console.log('White border', whiteBorder);
  const {paper, imageContainer, image, qualityWarning} = useImagePreview(file.size, containerSize, product, cropRect, whiteBorder, adaption);


  const style = {
    position: 'absolute',
    left: 0,
    top: 0,
    width: containerSize.width + 'px',
    height: containerSize.height + 'px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  };

  const paperStyle = {
    position: 'relative',
    width: paper.width,
    height: paper.height,
    backgroundColor: 'white',
    filter: 'drop-shadow(0px 0px 1px rgba(0,0,0,.3)) drop-shadow(0px 0px 10px rgba(0,0,0,.3))'
  };

  const imageContainerStyle = {
    position: 'absolute',
    width: imageContainer.width + 'px',
    height: imageContainer.height + 'px',
    top: imageContainer.y + 'px',
    left: imageContainer.x + 'px',
    overflow: 'hidden',
    /* Hack to make Safari hide overflow */
    zIndex: 0
  }

  const imageStyle = {
    position: 'absolute',
    width: image.width,
    height: image.height,
    top: image.y,
    left: image.x
  };


  return <div className={classes.orderLineImage} ref={ref}>
    <div style={style}>
      <div style={paperStyle}>
        <div style={imageContainerStyle}>
          <EpmsImage style={imageStyle} uuid={file.uuid} effect={filter} size={640}/>
        </div>
        {qualityWarning && <IconButton className={classes.qualityWarning}><Icon>warning</Icon></IconButton>}
      </div>
    </div>
  </div>
}